import { Box, Divider, SectionHelper, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import React from 'react';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
export const CrossPageNotification = () => {
  const {
    t
  } = useTranslation();
  const {
    capabilities
  } = useA11yWizardAdapter();
  const compactPanelChrome = capabilities.compactPanelChrome;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    margin: compactPanelChrome ? 'SP4' : '14px 20px'
  }, /*#__PURE__*/React.createElement(SectionHelper, {
    appearance: "standard",
    size: "small"
  }, /*#__PURE__*/React.createElement(Text, {
    size: compactPanelChrome ? 'small' : 'tiny',
    weight: "thin"
  }, t('accessibility-wizard.verticals-drill-in.content-section.page-specific-issues.cross-page-notification.content')))), !compactPanelChrome && /*#__PURE__*/React.createElement(Divider, null));
};
//# sourceMappingURL=cross-page-notification.js.map